/**
 * @generated SignedSource<<bc6f5be713160763d2e7917dff31cb33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteExpenseItemInput = {
  id?: string | null;
  projectId?: string | null;
  companyProjectId?: number | null;
  companyId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteExpenseItemMutation$variables = {
  input: DeleteExpenseItemInput;
};
export type deleteExpenseItemMutation$data = {
  readonly deleteExpenseItem: {
    readonly deletedExpenseItemId: string | null;
  } | null;
};
export type deleteExpenseItemMutation = {
  variables: deleteExpenseItemMutation$variables;
  response: deleteExpenseItemMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteExpenseItemPayload",
    "kind": "LinkedField",
    "name": "deleteExpenseItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedExpenseItemId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteExpenseItemMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteExpenseItemMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e22ff4831d434c60503fe40f7c512e12",
    "id": null,
    "metadata": {},
    "name": "deleteExpenseItemMutation",
    "operationKind": "mutation",
    "text": "mutation deleteExpenseItemMutation(\n  $input: DeleteExpenseItemInput!\n) {\n  deleteExpenseItem(input: $input) {\n    deletedExpenseItemId\n  }\n}\n"
  }
};
})();

(node as any).hash = "53a9f5382ff7b4c64ab49bf27a2fc0ea";

export default node;
